// Iryaa Homes brand mark — the botanical wreath with the IH monogram.
// The full-lockup version (with "Iryaa Homes" wordmark) lives at /iryaa-logo.png
// and can be imported directly where needed (e.g. hero splash / og image).
export default function Logo({ className = "w-10 h-10", alt = "Iryaa Homes" }) {
  return (
    <img
      src="/iryaa-mark.png"
      alt={alt}
      className={className}
      style={{ objectFit: "contain" }}
      draggable={false}
    />
  );
}
